<template>
    <div>
        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <div class="d-flex">
                                <!--                            <span v-for="occasion in item?.occasions" class="me-2 badge badge-info"> {{ occasion.name }} </span>-->
                                <div class="px-3 py-2">
                                    {{ $t('suitable gift for') }} :
                                </div>
                                <div class="row justify-content-center" v-if="item?.occasions?.length > 0 ">
                                    <div class="col-4 col-md-2 p-1" v-for="occasion in item?.occasions">
                                        <img :src="occasion?.icon" :alt="occasion?.name"
                                             class="img-thumbnail rounded-circle"
                                             data-bs-toggle="tooltip" data-bs-placement="top" :title="occasion?.name"
                                             height="30" width="30">
                                    </div>
                                </div>
                            </div>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active" v-for="category in item?.categories">
                                        {{ category?.name }}
                                    </li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- Product Left Sidebar Start -->
        <section class="product-section mb-3">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-xxl-9 col-xl-8 col-lg-7 wow fadeInUp">
                        <div class="row g-4">
                            <div class="col-xl-6 wow fadeInUp">
                                <div class="product-left-box">
                                    <div class="row g-2">
                                        <div class="col-xxl-10 col-lg-12 col-md-10 order-xxl-2 order-lg-1 order-md-2">
                                            <div class="product-main-2 no-arrow">

                                                <div class="slider-image" v-if="item?.image">
                                                    <img :src="item?.image" id="img-1"
                                                         :data-zoom-image="item?.image"
                                                         class="img-fluid image_zoom_cls-0 blur-up lazyload  w-100"
                                                         alt="">
                                                </div>

                                                <template v-for="img in item?.images">
                                                    <div class="slider-image">
                                                        <img :src="img?.path_url" id="img-1"
                                                             :data-zoom-image="img?.path_url"
                                                             class="img-fluid image_zoom_cls-0 blur-up lazyload  w-100"
                                                             alt="">
                                                    </div>
                                                </template>
                                            </div>
                                        </div>

                                        <div class="col-xxl-2 col-lg-12 col-md-2 order-xxl-1 order-lg-2 order-md-1">
                                            <div class="left-slider-image-2 left-slider no-arrow slick-top">

                                                <div class="sidebar-image" v-if="item?.image">
                                                    <img :src="item?.image"
                                                         class="img-fluid blur-up lazyload w-100" alt="">
                                                </div>

                                                <template v-for="img in item?.images">
                                                    <div class="sidebar-image">
                                                        <img :src="img?.path_url"
                                                             class="img-fluid blur-up lazyload w-100" alt="">
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-6 wow fadeInUp" data-wow-delay="0.1s">

                                <div class="right-box-contain">
                                    <!--                                <h6 class="offer-top">30% Off</h6>-->
                                    <h2 class="name"> {{ item?.name }} </h2>
                                    <div class="price-rating">


                                        <h3 class="theme-color price" v-if="item?.prices?.length === 0">
                                            <del class="text-content" v-if="item?.old_price != null">{{ item?.old_price }} {{ $t('SAR') }}</del>
                                            {{ item?.price_tax }}
                                            <span class="regular-price">
                                            {{ $t('SAR') }}
                                            </span>

                                            <span class="offer theme-color" v-if="item?.discount != null">({{ item?.discount }}% تخفيض)</span>
                                            <!--                                        <del class="text-content">$58.46</del>-->
                                            <!--                                        <span class="offer theme-color">(8% off)</span>-->
                                        </h3>


                                        <!--                                    <div class="product-rating custom-rate">-->
                                        <!--                                        <ul class="rating">-->
                                        <!--                                            <li>-->
                                        <!--                                                <i data-feather="star" class="fill"></i>-->
                                        <!--                                            </li>-->
                                        <!--                                            <li>-->
                                        <!--                                                <i data-feather="star" class="fill"></i>-->
                                        <!--                                            </li>-->
                                        <!--                                            <li>-->
                                        <!--                                                <i data-feather="star" class="fill"></i>-->
                                        <!--                                            </li>-->
                                        <!--                                            <li>-->
                                        <!--                                                <i data-feather="star" class="fill"></i>-->
                                        <!--                                            </li>-->
                                        <!--                                            <li>-->
                                        <!--                                                <i data-feather="star"></i>-->
                                        <!--                                            </li>-->
                                        <!--                                        </ul>-->
                                        <!--                                        <span class="review">23 Customer Review</span>-->
                                        <!--                                    </div>-->
                                    </div>

                                    <div class="procuct-contain">
                                        <p v-html="item?.description"></p>
                                    </div>



                                    <!--                                <div class="time deal-timer product-deal-timer mx-md-0 mx-auto" id="clockdiv-1"-->
                                    <!--                                     data-hours="1" data-minutes="2" data-seconds="3">-->
                                    <!--                                    <div class="product-title">-->
                                    <!--                                        <h4>Hurry up! Sales Ends In</h4>-->
                                    <!--                                    </div>-->
                                    <!--                                    <ul>-->
                                    <!--                                        <li>-->
                                    <!--                                            <div class="counter d-block">-->
                                    <!--                                                <div class="days d-block">-->
                                    <!--                                                    <h5></h5>-->
                                    <!--                                                </div>-->
                                    <!--                                                <h6>Days</h6>-->
                                    <!--                                            </div>-->
                                    <!--                                        </li>-->
                                    <!--                                        <li>-->
                                    <!--                                            <div class="counter d-block">-->
                                    <!--                                                <div class="hours d-block">-->
                                    <!--                                                    <h5></h5>-->
                                    <!--                                                </div>-->
                                    <!--                                                <h6>Hours</h6>-->
                                    <!--                                            </div>-->
                                    <!--                                        </li>-->
                                    <!--                                        <li>-->
                                    <!--                                            <div class="counter d-block">-->
                                    <!--                                                <div class="minutes d-block">-->
                                    <!--                                                    <h5></h5>-->
                                    <!--                                                </div>-->
                                    <!--                                                <h6>Min</h6>-->
                                    <!--                                            </div>-->
                                    <!--                                        </li>-->
                                    <!--                                        <li>-->
                                    <!--                                            <div class="counter d-block">-->
                                    <!--                                                <div class="seconds d-block">-->
                                    <!--                                                    <h5></h5>-->
                                    <!--                                                </div>-->
                                    <!--                                                <h6>Sec</h6>-->
                                    <!--                                            </div>-->
                                    <!--                                        </li>-->
                                    <!--                                    </ul>-->
                                    <!--                                </div>-->

                                    <CartButton :product="item" v-if="item?.id != null" :type="'big'"></CartButton>


                                    <!--                                <div class="buy-box">-->
                                    <!--                                    <a href="wishlist.html">-->
                                    <!--                                        <i data-feather="heart"></i>-->
                                    <!--                                        <span>Add To Wishlist</span>-->
                                    <!--                                    </a>-->
                                    <!--                                </div>-->

                                    <!--                                <div class="pickup-box">-->
                                    <!--                                    <div class="product-title">-->
                                    <!--                                        <h4>Store Information</h4>-->
                                    <!--                                    </div>-->
                                    <!--                                    <div class="pickup-detail">-->
                                    <!--                                        <h4 class="text-content">Lollipop cake chocolate chocolate cake dessert jujubes.-->
                                    <!--                                            Shortbread sugar plum dessert powder cookie sweet brownie.</h4>-->
                                    <!--                                    </div>-->
                                    <!--                                    <div class="product-info">-->
                                    <!--                                        <ul class="product-info-list product-info-list-2">-->
                                    <!--                                            <li>Type : <a href="javascript:void(0)">Black Forest</a></li>-->
                                    <!--                                            <li>SKU : <a href="javascript:void(0)">SDFVW65467</a></li>-->
                                    <!--                                            <li>MFG : <a href="javascript:void(0)">Jun 4, 2022</a></li>-->
                                    <!--                                            <li>Stock : <a href="javascript:void(0)">2 Items Left</a></li>-->
                                    <!--                                            <li>Tags : <a href="javascript:void(0)">Cake,</a> <a-->
                                    <!--                                                href="javascript:void(0)">Backery</a></li>-->
                                    <!--                                        </ul>-->
                                    <!--                                    </div>-->
                                    <!--                                </div>-->

                                    <div class="paymnet-option">
                                        <div class="product-title">
                                            <h4>{{ $t('Your financial transactions are safe') }}</h4>
                                        </div>
                                        <ul>
                                            <li>
                                                <img src="/theme/assets/images/more/telr.png"
                                                     class="blur-up lazyload mw-100" alt="" style="width: 300px">
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="product-section-box">
                                    <ul class="nav nav-tabs custom-nav" id="myTab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="description-tab" data-bs-toggle="tab"
                                                    data-bs-target="#description" type="button" role="tab"
                                                    aria-controls="description" aria-selected="true">
                                                {{ $t('Description') }}
                                            </button>
                                        </li>
                                    </ul>

                                    <div class="tab-content custom-tab" id="myTabContent">
                                        <div class="tab-pane fade show active" id="description" role="tabpanel"
                                             aria-labelledby="description-tab">
                                            <div class="product-description editor-content" v-html="item?.content"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xxl-3 col-xl-4 col-lg-5 d-none d-lg-block wow fadeInUp">
                        <div class="right-sidebar-box">

                            <div class="vendor-box" v-if="item.vendor !== null">

                                <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'vendor_id': item.vendor?.id } }">

                                <div class="verndor-contain  justify-content-center">
                                    <div class="vendor-image">
                                        <img :src="item.vendor?.avatar" class="blur-up lazyloaded" alt="">
                                    </div>

                                    <div class="vendor-name">
                                        <h5 class="fw-500">{{ item.vendor?.name }}</h5>
                                    </div>
                                </div>

                                </router-link>

                                <p class="vendor-detail">{{ item.vendor?.bio }}</p>

<!--                                <div class="vendor-list">-->
<!--                                    <ul>-->
<!--                                        <li>-->
<!--                                            <div class="address-contact">-->
<!--                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>-->
<!--                                                <h5>Address: <span class="text-content">1288 Franklin Avenue</span></h5>-->
<!--                                            </div>-->
<!--                                        </li>-->

<!--                                        <li>-->
<!--                                            <div class="address-contact">-->
<!--                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-headphones"><path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path></svg>-->
<!--                                                <h5>Contact Seller: <span class="text-content">(+1)-123-456-789</span></h5>-->
<!--                                            </div>-->
<!--                                        </li>-->
<!--                                    </ul>-->
<!--                                </div>-->
                            </div>




                            <!-- Trending Product -->
                            <div class="pt-25">
                                <div class="category-menu">
                                    <h3>{{ $t('Trending Products') }}</h3>

                                    <ul class="product-list product-right-sidebar border-0 p-0">

                                        <li v-for="product in trending">
                                            <div class="offer-product">
                                                <router-link
                                                    :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"
                                                    class="offer-image">
                                                    <img
                                                        :src="product.image ?? '/theme/assets/images/more/gift-card.png'"
                                                        class="img-fluid blur-up lazyload" alt="">
                                                </router-link>

                                                <div class="offer-detail">
                                                    <div>
                                                        <router-link
                                                            :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                            <h6 class="name">{{ product?.name }}</h6>
                                                        </router-link>
                                                        <!--                                                    <span>450 G</span>-->
                                                        <h6 class="price theme-color">{{ product?.price_tax }}
                                                            {{ $t('SAR') }}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Product Left Sidebar End -->

        <!-- Releted Product Section Start -->
        <section class="product-list-section section-b-space" v-if="related?.length > 0">
            <div class="container-fluid-lg">
                <div class="title">
                    <h2>{{ $t('Related Products') }}</h2>
                    <span class="title-leaf">
                    <svg class="icon-width">
                        <use xlink:href="/theme/assets/svg/leaf.svg#leaf"></use>
                    </svg>
                </span>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="slider-6_1 product-wrapper">

                            <div v-for="product in related" :key="product.id">

                                <div class="product-box-3 h-100 wow fadeInUp">
                                    <div class="product-header">
                                        <div class="product-image">
                                            <router-link
                                                :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                <img :src="product.image ?? '/theme/assets/images/more/gift-card.png'"
                                                     class="img-fluid blur-up lazyload  w-100" alt="">
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="product-footer">
                                        <div class="product-detail">

                                            <div class="row justify-content-center"
                                                 v-if="product?.occasions?.length > 0 ">

                                                <div class="col-4 col-md-2 p-1" v-for="occasion in product?.occasions">
                                                    <img :src="occasion?.icon" :alt="occasion?.name"
                                                         class="img-thumbnail rounded-circle"
                                                         data-bs-toggle="tooltip" data-bs-placement="top"
                                                         :title="occasion?.name"
                                                         height="35" width="35">
                                                </div>

                                            </div>

                                            <router-link
                                                :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                <h5 class="name"> {{ product?.name }} </h5>
                                            </router-link>
                                            <p class="text-content mt-1 mb-2 product-content">
                                                {{ product?.description }}
                                            </p>
                                            <h5 class="d-flex justify-content-end">
                                                <h5 class="price">
                                                    <span class="theme-color">
                                                        {{ product?.price_tax }}
                                                        {{ $t('SAR') }}
                                                    </span>
                                                </h5>
                                            </h5>

                                            <CartButton :product="product" :type="'box'"></CartButton>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Releted Product Section End -->

    </div>
</template>

<script>
import {useToast} from "vue-toastification";
import CartButton from "../cart_item/CartButton.vue";
import {Head, useHead} from "@vueuse/head"

const toast = useToast();
// import Vue from 'vue'; // Import Vue.js

export default {
    components: {CartButton},
    data() {
        return {
            item: [],
            trending: [],
            related: []
        }
    },
    async created() {

        const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-solid fa-download'});

        await axios.get(`products/${this.$route.params.id}`, {}).then(response => {
            this.item = response.data.data;
            this.trending = response.data.trending;
            this.related = response.data.related;
            toast.dismiss(id);
        }, response => {
            if (response.response.status === 404) {
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});
            }
            toast.dismiss(id);
        });

        this.playSlider();

        useHead({
            title: this.item?.name,
        })
    },
    methods: {
        playSlider() {
            console.log('playSlider');

            setTimeout(function () {
                $('.slider-6_1').slick({
                    arrows: false,
                    infinite: true,
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    dots: true,
                    responsive: [{
                        breakpoint: 1430,
                        settings: {
                            slidesToShow: 5,
                            autoplay: true,
                            autoplaySpeed: 3500,
                        }
                    },
                        {
                            breakpoint: 1199,
                            settings: {
                                slidesToShow: 4,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                    ]
                });


                $('.product-main-2').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: '.left-slider-image-2'
                });

                $('.left-slider-image-2').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    asNavFor: '.product-main-2',
                    dots: false,
                    focusOnSelect: true,
                    vertical: true,
                    responsive: [{
                        breakpoint: 1400,
                        settings: {
                            vertical: false,
                        }
                    },
                        {
                            breakpoint: 992,
                            settings: {
                                vertical: true,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                vertical: false,
                            }
                        }, {
                            breakpoint: 430,
                            settings: {
                                slidesToShow: 3,
                                vertical: false,
                            }
                        },
                    ]
                });
            }, 350);
        }
    }
}
</script>
